import React, { useEffect, useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, ShoppingCart } from 'lucide-react';
const notifications = [{
  name: 'Alejandra M.',
  location: 'Córdoba, Argentina'
}, {
  name: 'Diego R.',
  location: 'Medellín, Colombia'
}, {
  name: 'Valentina S.',
  location: 'Santiago, Chile'
}, {
  name: 'Fernando L.',
  location: 'Quito, Ecuador'
}, {
  name: 'Camila P.',
  location: 'Guadalajara, México'
}, {
  name: 'Martín G.',
  location: 'Asunción, Paraguay'
}, {
  name: 'Sofía T.',
  location: 'Caracas, Venezuela'
}, {
  name: 'Joaquín B.',
  location: 'San José, Costa Rica'
}, {
  name: 'Paula H.',
  location: 'Santo Domingo, Rep. Dominicana'
}, {
  name: 'Nicolás V.',
  location: 'La Paz, Bolivia'
}];
export function SocialProofPopup() {
  const [current, setCurrent] = useState<number | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  const timersRef = useRef<ReturnType<typeof setTimeout>[]>([]);
  useEffect(() => {
    const addTimer = (fn: () => void, delay: number) => {
      const id = setTimeout(fn, delay);
      timersRef.current.push(id);
      return id;
    };
    const showNext = () => {
      const nextIndex = Math.floor(Math.random() * notifications.length);
      setCurrent(nextIndex);
      setIsVisible(true);
      addTimer(() => setIsVisible(false), 4000);
      const delay = Math.random() * 4000 + 8000;
      addTimer(showNext, delay + 4000);
    };
    addTimer(showNext, 5000);
    return () => {
      timersRef.current.forEach(clearTimeout);
      timersRef.current = [];
    };
  }, []);
  if (current === null) return null;
  return <AnimatePresence data-id="element-378">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      x: -20
    }} className="fixed bottom-24 md:bottom-6 left-4 md:left-6 z-50" data-id="element-379">
          <div className="bg-white border border-gray-200 rounded-xl shadow-2xl p-4 pr-12 flex items-center gap-4 max-w-sm relative" data-id="element-380">
            <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600 transition-colors" aria-label="Cerrar notificación" data-id="element-381">
              <X className="w-3 h-3" data-id="element-382" />
            </button>

            <div className="bg-green-100 p-2 rounded-full flex-shrink-0" data-id="element-383">
              <ShoppingCart className="w-5 h-5 text-[#16A34A]" data-id="element-384" />
            </div>

            <div data-id="element-385">
              <p className="text-sm font-bold text-gray-900" data-id="element-386">
                {notifications[current].name}
              </p>
              <p className="text-xs text-gray-500" data-id="element-387">
                de {notifications[current].location}
              </p>
              <p className="text-xs text-[#16A34A] font-semibold mt-0.5" data-id="element-388">
                acaba de comprar el MegaPack
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}